export default __webpack_public_path__ + "static/media/person3.53878b11.jpg";